export const getAccessToken = () => localStorage.getItem('accessToken');
export const getRefreshToken = () => localStorage.getItem('refreshToken');

export const setTokens = ({ accessToken, refreshToken }) => {
  if (accessToken) localStorage.setItem('accessToken', accessToken);
  if (refreshToken) localStorage.setItem('refreshToken', refreshToken);
};

export const clearTokens = () => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('subdomain');
  sessionStorage.removeItem("activeEventTab");
};

export const getSubdomain = () => localStorage.getItem('subdomain');
export const setSubdomain = (subdomain) => localStorage.setItem('subdomain', subdomain);